import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewChild} from '@angular/core';
import {ProductListComponent} from '@app/product-list/product-list.component';
import {UUID} from '@util/types';
import {ProductStatus} from '@services/model/product';
import {MatIcon} from '@angular/material/icon';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-new-products',
  templateUrl: './new-products.component.html',
  styleUrls: ['./new-products.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ProductListComponent, MatIcon],
})
export class NewProductsComponent {
  @Input() cycle: UUID | undefined;

  @Input() statusIn?: ProductStatus[];

  @ViewChild(ProductListComponent)
  productList: ProductListComponent;

  constructor(private readonly cd: ChangeDetectorRef) {}

  prev() {
    this.productList.previousPage();
    this.cd.markForCheck();
  }

  next() {
    this.productList.nextPage();
    this.cd.markForCheck();
  }
}
